let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cePpp")).then(() => parcelRequire('7YRwQ'));